module.exports = "<div *ngIf=\"type === 'apwd'\">\r\n  <app-advisor-pass></app-advisor-pass>\r\n</div>"